@if (page(); as page) {
  <button mat-button type="button" (click)="openStatusPage()" [matTooltip]="page.status.description">
    <div class="flex flex-row gap-2 items-center">
      <mat-icon [classList]="[getColor(page.status.indicator)]">{{ getIcon(page.status.indicator) }}</mat-icon>
      <span>Status</span>
    </div>
  </button>
} @else {
  <button mat-button type="button" (click)="openStatusPage()">
    <div class="flex flex-row gap-2 items-center">
      <mat-spinner diameter="18"></mat-spinner>
      <span>Status</span>
    </div>
  </button>
}
